var _rect, _rect2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "url(#paint0_linear_13628_92334)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E3C210"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3029 13.9718L19.7873 17.0054L20.8583 21.5421C20.9174 21.7884 20.9022 22.0466 20.8146 22.2843C20.727 22.5219 20.5709 22.7282 20.3661 22.8772C20.1613 23.0262 19.9169 23.1111 19.6639 23.1213C19.4108 23.1314 19.1604 23.0663 18.9443 22.9343L14.999 20.5061L11.0513 22.9343C10.8352 23.0656 10.5851 23.13 10.3325 23.1195C10.0799 23.109 9.83603 23.0239 9.63163 22.8751C9.42724 22.7262 9.27146 22.5202 9.1839 22.283C9.09634 22.0458 9.08093 21.788 9.1396 21.5421L10.2146 17.0054L6.69897 13.9718C6.5078 13.8065 6.36954 13.5887 6.30146 13.3453C6.23338 13.102 6.2385 12.844 6.31617 12.6035C6.39385 12.3631 6.54064 12.1509 6.73822 11.9933C6.93579 11.8358 7.17539 11.74 7.4271 11.7179L12.0365 11.346L13.8146 7.04286C13.9108 6.80834 14.0747 6.60774 14.2852 6.46656C14.4957 6.32538 14.7435 6.25 14.997 6.25C15.2505 6.25 15.4983 6.32538 15.7088 6.46656C15.9194 6.60774 16.0832 6.80834 16.1794 7.04286L17.9568 11.346L22.5662 11.7179C22.8184 11.7392 23.0587 11.8345 23.257 11.9918C23.4553 12.1491 23.6027 12.3614 23.6809 12.6021C23.759 12.8429 23.7644 13.1013 23.6963 13.3451C23.6283 13.5889 23.4898 13.8071 23.2982 13.9725L23.3029 13.9718Z",
    fill: "#666D80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_13628_92334)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 8,
    r: 3,
    fill: "#ECEFF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13628_92334",
    x: 15,
    y: 1,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_13628_92334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13628_92334",
    x1: 0,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0CC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0BF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0BF10"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBatch);
export default __webpack_public_path__ + "static/media/yellowBatch.8b31ec7e3015c279792404dcb212a384.svg";
export { ForwardRef as ReactComponent };